import { isIsoDate } from './calendar/calendarDates';
import { isMonth } from './month/monthModel';

/** Das Lesemodell trägt 90 Tage; 60 kam mit der Ablösung des Preisautomatik-Kalenders dazu. */
export const AVAILABILITY_ZOOMS = [7, 14, 30, 60] as const;
export type AvailabilityZoom = (typeof AVAILABILITY_ZOOMS)[number];
export type AvailabilityTab = 'calendar' | 'channels';

/**
 * URL-Zustand von Verfügbarkeit & Vertrieb; neue Parameter kommen nur hinzu. Mit `apartment`
 * zeigt der Grundkalender-Reiter den Monat dieses Apartments (`month`, sonst der laufende), `day`
 * wählt dort einen Tag vor – so landen alte Links aus dem Preisautomatik-Kalender.
 */
export interface AvailabilitySearch {
  from?: string;
  days?: AvailabilityZoom;
  tab?: AvailabilityTab;
  apartment?: string;
  month?: string;
  day?: string;
}

const isId = (value: unknown): value is string =>
  typeof value === 'string' && /^[A-Za-z0-9-]{1,64}$/.test(value);

export function validateAvailabilitySearch(search: Record<string, unknown>): AvailabilitySearch {
  return {
    from: isIsoDate(search.from) ? search.from : undefined,
    days: AVAILABILITY_ZOOMS.find((zoom) => String(zoom) === String(search.days)),
    tab: search.tab === 'channels' ? 'channels' : undefined,
    apartment: isId(search.apartment) ? search.apartment : undefined,
    month: isMonth(search.month) ? search.month : undefined,
    day: isIsoDate(search.day) ? search.day : undefined,
  };
}
